import { useNavigate } from 'react-router-dom';

import { useCommandPaletteStore } from '../store';

export const useContractNavigation = () => {
  const navigate = useNavigate();
  const close = useCommandPaletteStore((state) => state.close);
  return (link: string, openInNewTab: boolean) => {
    if (openInNewTab) {
      window.open(link, '_blank', 'noopener');
    } else {
      navigate(link);
      close();
    }
  };
};
